import React from 'react';
import { Box, useTheme } from '@mui/material';
import HeaderSearch from './Search';
import HeaderNotifications from './Notifications';

const HeaderButtons: React.FC = () => {
  // Visual-only: Full Modern keeps its spacing; classic lines the icons up on a 4px rhythm.
  const isModern = Boolean((useTheme() as any).isModern);
  return (
    <Box sx={isModern ? { mr: 1 } : { display: 'flex', alignItems: 'center', gap: '4px', mr: '4px' }}>
      <HeaderSearch />
      <Box sx={isModern ? { mx: 0.5 } : { display: 'inline-flex' }} component="span">
        <HeaderNotifications />
      </Box>
    </Box>
  );
};

export default HeaderButtons;
